import { Eye, MapPin, TrendingUp, Headphones } from "lucide-react";

const PILLARS = [
    {
        icon: Eye,
        title: "Contabilidad preventiva, no reactiva",
        desc: "Analizamos tus números de forma continua para detectar alertas antes de que se conviertan en problemas. Inspecciones de BPS o DGI, vencimientos, desequilibrios: te avisamos antes.",
        quote: "Tu contador debería darte respuestas antes de que tengas las preguntas.",
    },
    {
        icon: MapPin,
        title: "Presencia local en Rocha y Castillos",
        desc: "Conocemos la realidad del interior uruguayo porque vivimos y trabajamos acá. Atención presencial en dos sedes, sin intermediarios ni trámites a distancia cuando no hace falta.",
        quote: "Cerca tuyo cuando lo necesites.",
    },
    {
        icon: TrendingUp,
        title: "Información para crecer, no solo para cumplir",
        desc: "Tus estados financieros no son un trámite. Son una herramienta. Los trabajamos para que entiendas qué dice tu empresa hoy y qué decisiones podés tomar mañana.",
        quote: "Los datos de tu empresa al servicio de su crecimiento.",
    },
    {
        icon: Headphones,
        title: "Acompañamiento real, no solo mensual",
        desc: "No desaparecemos entre liquidación y liquidación. Estamos disponibles para consultas, decisiones importantes y situaciones que no pueden esperar a fin de mes.",
        quote: "Parte de tu equipo, no un servicio externo.",
    },
];

const STATS = [
    { num: "2", label: "Sedes en Rocha\ny Castillos" },
    { num: "0$", label: "Primera consulta\nsin costo" },
    { num: "100%", label: "Atención\npersonalizada" },
];

export default function Problem() {
    return (
        <section
            id="diferenciales"
            data-testid="problem-section"
            className="relative bg-[var(--uma-cream-soft)] py-24 md:py-32 overflow-hidden"
        >
            <div className="relative max-w-7xl mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-14 md:mb-20">
                    <div className="lg:col-span-7 reveal">
                        <div className="uma-eyebrow left">
                            <span>Por qué elegirnos</span>
                        </div>
                        <h2 className="font-serif-display text-[36px] md:text-[56px] lg:text-[68px] leading-[1] mt-6 text-[var(--uma-forest)]">
                            Un estudio que se integra
                            <br />
                            <em className="italic font-light text-[var(--uma-gold)]">
                                a tu empresa.
                            </em>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 reveal">
                        <p className="text-[16px] md:text-[17px] leading-relaxed text-[var(--uma-text-soft)] font-light">
                            No somos un servicio externo que aparece cuando hay
                            un problema. Somos parte de tu equipo, con
                            información y criterio para acompañarte{" "}
                            <span className="text-[var(--uma-forest)] font-medium">
                                antes de que el problema llegue.
                            </span>
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {PILLARS.map((p, i) => {
                        const Icon = p.icon;
                        return (
                            <div
                                key={i}
                                data-testid={`pain-card-${i}`}
                                className="reveal group bg-[var(--uma-cream-white)] border border-[var(--uma-forest)]/8 rounded-2xl p-7 md:p-10 relative transition-all hover:-translate-y-1 hover:shadow-[0_18px_50px_-20px_rgba(10,38,20,0.18)]"
                            >
                                <div className="flex items-center justify-between mb-7">
                                    <div className="w-12 h-12 rounded-xl bg-[var(--uma-cream-soft)] text-[var(--uma-forest)] flex items-center justify-center group-hover:bg-[var(--uma-forest)] group-hover:text-[var(--uma-gold)] transition-colors">
                                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                                    </div>
                                    <span className="text-[10px] uppercase tracking-[0.2em] text-[var(--uma-text-soft)] group-hover:text-[var(--uma-gold)] transition-colors">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="font-serif-display text-[24px] md:text-[28px] leading-tight text-[var(--uma-forest)]">
                                    {p.title}
                                </h3>
                                <p className="mt-4 text-[14px] md:text-[15px] leading-relaxed text-[var(--uma-text-soft)] font-light">
                                    {p.desc}
                                </p>
                                <div className="mt-6 pt-5 border-t border-[var(--uma-forest)]/8">
                                    <p className="font-serif-display italic text-[15px] md:text-[16px] text-[var(--uma-gold)]">
                                        "{p.quote}"
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Stats row */}
                <div className="reveal mt-12 grid grid-cols-3 gap-3 md:gap-6">
                    {STATS.map((s, i) => (
                        <div
                            key={i}
                            data-testid={`pain-stat-${i}`}
                            className="text-center px-4 py-8 rounded-2xl bg-[var(--uma-cream-white)] border border-[var(--uma-forest)]/8"
                        >
                            <div className="font-serif-display text-[44px] md:text-[60px] text-[var(--uma-gold)] leading-none italic">
                                {s.num}
                            </div>
                            <div className="mt-3 text-[11px] md:text-[12px] uppercase tracking-[0.18em] text-[var(--uma-text-soft)] whitespace-pre-line">
                                {s.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
